import { Helmet } from 'react-helmet-async';
import { Grid } from '@mui/material';
import UserView from '../../../components/dashboard/home/user/UserView';

export default function SingleUser() {
  return (
    <>
      <Helmet>
        <title>User | Platform Solutions</title>
      </Helmet>

      <Grid item xl={12}>
        <Grid container spacing={3} direction="row" justifyContent="flex-start" alignItems="flex-start">
          <UserView />
        </Grid>
      </Grid>
    </>
  );
}
